import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { ProductType } from '../../../shared/enums/product-type';

@Component({
  selector: 'app-public-product-name',
  imports: [RouterLinkComponent],
  templateUrl: './public-product-name.component.html',
  styleUrl: './public-product-name.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductNameComponent {
  public readonly type = input.required<ProductType>();
  public readonly slug = input.required<string>();

  protected readonly routerLink = this.routerLinkSignal();

  private routerLinkSignal(): Signal<{
    route: Route;
    params: RouterLinkParams;
  }> {
    return computed(() => {
      switch (this.type()) {
        case ProductType.Box:
          return {
            route: Route.PL_BoxDetails,
            params: {
              [RouteParam.Slug]: this.slug(),
            },
          };

        default:
          return {
            route: Route.PL_ProductDetails,
            params: {
              [RouteParam.Slug]: this.slug(),
            },
          };
      }
    });
  }
}
